<template>
  <v-container fill-height class="justify-center">
    <v-card class="pa-8 text-center" max-width="480" role="status" aria-live="polite">
      <template v-if="loading">
        <v-progress-circular indeterminate color="primary" class="mb-4" />
        <h1 class="text-h5 mb-3">Abrindo a conta</h1>
        <p class="mb-0">Aguarde enquanto preparamos o acesso.</p>
      </template>
      <template v-else>
        <h1 class="text-h5 mb-3">Não foi possível abrir a conta</h1>
        <p>Volte ao Admin e clique em Abrir frontend novamente.</p>
        <v-btn color="primary" :href="adminUrl">Voltar ao Admin</v-btn>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import http from '../services/httpClient';
import { loginFromAdmin } from '../plugins/tokenLogin';
import { consumeAdminLoginToken } from '../utils/adminLogin';

export default {
  name: 'AdminLogin',
  data() {
    return {
      loading: true,
      adminUrl: `${http.defaults.baseURL.replace(/\/$/, '')}/admin/`,
    };
  },
  async created() {
    const token = consumeAdminLoginToken();
    try {
      await loginFromAdmin(this.$router, token);
    } catch (error) {
      this.loading = false;
    }
  },
};
</script>
